import DocumentTypeManager from "./fleet/DocumentTypeManager";

/**
 * Submenú: Documentos y Vigencia → Tipos de Documento
 * Wrapper del módulo fleet — gestión de tipos de documento
 * con campos personalizados, entidades y configuración de alertas
 */
const TiposDocumento = () => {
  return <DocumentTypeManager />;
};

export default TiposDocumento;
